<template>
  <div class="operational-dashboard-section">
    <div class="operational-dashboard-section__header">
      <h4 class="operational-dashboard-section__title">
        {{ $t('OPERATIONAL_DASHBOARD.DISTRIBUTION.TITLE') }}
      </h4>
      <woot-tabs :index="activeIndex" :border="false" @change="onTabChange">
        <woot-tabs-item
          v-for="tab in tabs"
          :key="tab.key"
          :name="tab.name"
          :show-badge="false"
        />
      </woot-tabs>
    </div>
    <horizontal-bar
      v-for="row in rows"
      :key="row.name"
      :label="row.name"
      :count="row.count"
      :total="activeGroup.total"
      color="#1E3A8A"
    />
  </div>
</template>

<script>
import HorizontalBar from './HorizontalBar.vue';

export default {
  name: 'DistributionBreakdown',
  components: { HorizontalBar },
  props: {
    conversationsByTeam: {
      type: Object,
      default: () => ({ items: [], total: 0 }),
    },
    conversationsByInbox: {
      type: Object,
      default: () => ({ items: [], total: 0 }),
    },
  },
  data() {
    return { activeIndex: 0 };
  },
  computed: {
    tabs() {
      return [
        {
          key: 'team',
          name: this.$t('OPERATIONAL_DASHBOARD.DISTRIBUTION.BY_TEAM'),
        },
        {
          key: 'inbox',
          name: this.$t('OPERATIONAL_DASHBOARD.DISTRIBUTION.BY_INBOX'),
        },
      ];
    },
    activeGroup() {
      return this.activeIndex === 0
        ? this.conversationsByTeam
        : this.conversationsByInbox;
    },
    rows() {
      const items = this.activeGroup.items || [];
      const allLabel = this.$t('OPERATIONAL_DASHBOARD.DISTRIBUTION.ALL');
      return [...items, { name: allLabel, count: this.activeGroup.total }];
    },
  },
  methods: {
    onTabChange(index) {
      this.activeIndex = index;
    },
  },
};
</script>

<style lang="scss" scoped>
.operational-dashboard-section {
  background: var(--white);
  border: 1px solid var(--color-border);
  border-radius: var(--border-radius-medium);
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: var(--space-medium) var(--space-large);

  &__title {
    color: var(--s-900);
    font-size: var(--font-size-medium);
    font-weight: var(--font-weight-bold);
  }

  &__header {
    align-items: center;
    display: flex;
    flex-wrap: wrap;
    gap: var(--space-small);
    justify-content: space-between;
    margin-bottom: var(--space-medium);
  }
}

::v-deep .tabs--container {
  margin: 0;
  min-height: 0;
}
</style>
